"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomQuestion = exports.CustomQuestionButtonGroup = exports.ResponseOptionsWrapper = void 0;
var aon_tws_common_ui_1 = require("@aon/aon-tws-common-ui");
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var contentConstants_1 = __importDefault(require("../../../contentConstants"));
var models_1 = require("../../../models");
var utilities_1 = require("../../../utilities");
var common_1 = require("../../common");
var response_options_1 = require("../../response-options");
var _1 = require("./");
var MappedAttributeSection_1 = require("./MappedAttributeSection");
exports.ResponseOptionsWrapper = (0, styled_components_1.default)('div').attrs({
    className: 'tws-custom-response-options-selector',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tmargin: 40px 0;\n"], ["\n\tmargin: 40px 0;\n"])));
exports.CustomQuestionButtonGroup = (0, styled_components_1.default)('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\ttext-align: right;\n\tmargin-top: 40px;\n\n\t.btn {\n\t\tmargin-left: 10px;\n\t}\n"], ["\n\ttext-align: right;\n\tmargin-top: 40px;\n\n\t.btn {\n\t\tmargin-left: 10px;\n\t}\n"])));
var CustomQuestion = /** @class */ (function (_super) {
    __extends(CustomQuestion, _super);
    function CustomQuestion(props) {
        var _this = _super.call(this, props) || this;
        _this.SetUploadResponseOptionsState = function (file) {
            _this.props.SetUploadResponseOptionsState(file);
        };
        _this.DownloadResponseOptionsTemplate = function () {
            _this.props.OnDownloadResponseOptionsTemplate();
        };
        _this.UploadResponseOptions = function (data, sourceResponseOptionGroupId) {
            _this.props.OnUploadResponseOptions(data, sourceResponseOptionGroupId);
        };
        _this.state = {
            validationHelper: new utilities_1.ValidationHelper(_this.props.validationResults),
        };
        _this.save = _this.save.bind(_this);
        _this.resetAndFinish = _this.resetAndFinish.bind(_this);
        _this.getButtonText = _this.getButtonText.bind(_this);
        return _this;
    }
    CustomQuestion.prototype.componentDidMount = function () {
        this.props.GetCustomQuestion(this.props.isDemographic, this.props.questionId);
        if (!this.props.isDemographic) {
            this.props.GetResponseOptionGroups();
        }
    };
    CustomQuestion.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (this.props.saving && !nextProps.saving && !nextProps.unsavedQuestionChanges) {
            var validationHelper_1 = new utilities_1.ValidationHelper(nextProps.validationResults);
            this.setState({
                validationHelper: validationHelper_1,
            }, function () {
                if (validationHelper_1.IsValid()) {
                    _this.props.ResetCustomQuestion();
                    _this.props.OnFinish();
                }
            });
        }
    };
    CustomQuestion.prototype.save = function () {
        this.props.SaveCustomQuestion();
    };
    CustomQuestion.prototype.resetAndFinish = function () {
        if (this.props.unsavedQuestionChanges) {
            this.props.ToggleWarningModal(true);
        }
        else {
            this.props.ResetCustomQuestion();
            this.props.OnFinish();
        }
    };
    CustomQuestion.prototype.render = function () {
        var _a = this.props, fromQuestionModal = _a.fromQuestionModal, isDemographic = _a.isDemographic, question = _a.question, translations = _a.translations, questionId = _a.questionId, loading = _a.loading, responseOptionGroupsLoading = _a.responseOptionGroupsLoading, validationResults = _a.validationResults, attributes = _a.attributes, selectedAttributes = _a.selectedAttributes, onAttributeSelect = _a.onAttributeSelect;
        var validationHelper = new utilities_1.ValidationHelper(validationResults);
        var responseOptionValidation = validationHelper.GetValidationResultForProperty(models_1.CustomQuestionPropertyUnderValidation.responseOptions);
        var attributeNameValidation = validationHelper.GetValidationResultForProperty(models_1.CustomQuestionPropertyUnderValidation.attributeName);
        if (loading) {
            return (React.createElement(common_1.LoadingWrapper, null,
                React.createElement(aon_tws_common_ui_1.Loading, { height: '70px', width: '70px' })));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(_1.QuestionTextSection, { translationEmptyRow: true, questionId: questionId, textValue: this.props.defaultTextValue, translationDeleteColumn: true, translations: translations, validationResult: {}, onTextChange: this.props.HandleQuestionTextChange, onTranslationChange: this.props.HandleTranslationChange }),
            !isDemographic && (React.createElement(response_options_1.ResponseOptionsSelector, __assign({}, this.props, { loading: responseOptionGroupsLoading, validationResult: responseOptionValidation }))),
            isDemographic && (React.createElement(React.Fragment, null,
                React.createElement(MappedAttributeSection_1.MappedAttributeSection, { selected: question.externalAttributeColumnName, validationResult: attributeNameValidation, attributes: attributes, selectedAttributes: selectedAttributes, onSelect: onAttributeSelect }),
                React.createElement(_1.CustomResponseOptionsSection, __assign({}, this.props, { isFollowUpEnabled: true, validationResult: validationResults, disableDownloadAndUploadResponseOptionTemplateButton: this.props.disableDownloadAndUploadResponseOptionTemplateButton, OnDownloadResponseOptionsTemplate: this.DownloadResponseOptionsTemplate, OnUploadResponseOptions: this.UploadResponseOptions, sourceResponseOptionGroupId: 0, SetUploadResponseOptionsState: this.SetUploadResponseOptionsState })))),
            React.createElement(aon_tws_common_ui_1.Divider, { type: 'dashed' }),
            React.createElement(exports.CustomQuestionButtonGroup, null,
                fromQuestionModal && (React.createElement(aon_tws_common_ui_1.Button, { size: 'lg', color: 'secondary', id: 'BackButton', onClick: this.resetAndFinish }, contentConstants_1.default.BUTTONS_BACK_TO_QUESTIONS)),
                React.createElement(aon_tws_common_ui_1.Button, { size: 'lg', color: 'primary', onClick: this.save, disabled: this.saveDisabled() }, this.getButtonText()))));
    };
    CustomQuestion.prototype.saveDisabled = function () {
        if (this.props.saving) {
            return true;
        }
        if (this.props.questionId !== undefined && this.props.questionId > 0 && !this.props.unsavedQuestionChanges) {
            return true;
        }
        if (this.props.isDemographic || this.props.questionType === models_1.QuestionType.OpenEnded) {
            return false;
        }
        return false;
    };
    CustomQuestion.prototype.getButtonText = function () {
        if (this.props.questionId && this.props.questionId > 0) {
            return contentConstants_1.default.BUTTONS_UPDATE_QUESTION;
        }
        else {
            return contentConstants_1.default.BUTTONS_CREATE_QUESTION;
        }
    };
    return CustomQuestion;
}(React.PureComponent));
exports.CustomQuestion = CustomQuestion;
var templateObject_1, templateObject_2;
